module.exports = __webpack_public_path__ + "static/media/headerPic.7f5ead78.jpg";